import React from 'react';
import Image from "next/image";
import Link from "next/link";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import styles from "./mock.module.css";
//import TnpscInterview from "../../assets/images/Tnpsc/Tnpsc-Grp-I-Mock-Interview-web banner.jpg";
//import MobBanner from "../../assets/images/Tnpsc/Tnpsc-Grp-I-Mock-Interview-Mobile-Banner.jpg";
import Head from "next/head";

const TnpscGroupIMockInterview = () => {

    const prelimlist =[
        {list:"Free – Shankar IAS Academy Students can avail this programme at free of charge provided if they provide any proof for having done any programme at Shankar IAS Academy"},
        {list:"Rs. 50/- - For others (One Time Fee)"},
       
        ,
      ]

    return (
        <>
        <Head>
        <meta charset="UTF-8" />
        
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noodp,noydir" />
        <meta name="robots" content="index,follow" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>TNPSC Group I Mock Interview Registration 2025 </title>
        <meta name="title" content="TNPSC Group I Mock Interview Registration 2025" />
        <meta name="description" content=" Get TNPSC Group I Mock Interview 2025 experience with expert guidance. Practice, receive feedback, and refine your interview skills for better results." />
        <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-I-mock-interview/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="TNPSC Group I Mock Interview Registration 2025" />
        <meta property="og:description" content="Get TNPSC Group I Mock Interview experience with expert guidance. Practice, receive feedback, and refine your interview skills for better results." />
        <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-I-mock-interview/" />
        <meta property="og:site_name" content="Shankar IAS Academy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@shankarias" />
    </Head>    

    <Navbar title="Tnpsc-Interview-2025" />

    <div className="container">
      <div className="row">
            <div className="col pt-3 pt-md-4">
                <h1 className={`${styles.pagemaintitle}`}>TNPSC Group I Mock Interview  Programme 2025</h1>
            </div>
      </div>


      {/* <div className="row d-none d-md-block">
            <div className="col pt-3 pt-md-2">
              <Image src={TnpscInterview} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group I Prelims Test" className="img-fluid w-100"/>
            </div>
      </div>
      
      <div className="row d-block d-md-none">
            <div className="col pt-3 pt-md-5">
                <Image src={MobBanner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group I Prelims Test" className="img-fluid w-100"/>
            </div>
      </div>  */}

     

        <div className={`${styles.bgbox} row`}>
         
            <div className="d-flex justify-content-center py-3 py-md-5">
                <Link href="https://forms.gle/Y81NUxBD5e7N9RWP8" target="_blank" className={`${styles.btnbox}`}>
                <p className="pt-3">Tnpsc Group I Mock Interview<br/> Registration 2025</p>
                <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                </Link>
            </div>
        </div>
    </div>

    <div className="container pt-3 pt-md-4">

            <div className="row">
                <div className="col">
                    <h2 className={`${styles.contactheader}`}> Group I Mock Interview Programme Features </h2>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 col-lg-4 col-xl-4 text-center pt-md-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <h2 className={`${styles.acheivername1} mb-2`}>Components of SIA Mock Interview :</h2>
                        <ul className="mock-interview-list pt-2" style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Mock Interviews – a student can attend maximum of 5 mock interview panels based on request to the SIA Interview Team.</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Exclusive Class and Videos for Mock Interview related to Group I Services and Current Affairs</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Recorded Videos of the Mock Interview Candidates for review</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Personalized One to One Guidance under the Mentorship of UK Sivabalan and Team.</li>
                       </ul>

                       <h3 className={`${styles.acheiverfee} pt-4 mb-2`}>Programme Fee :</h3>
                       <ul className="mock-interview-list pt-2" style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                       <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span style={{color: '#0d3fb0'}}> Free – </span>Shankar IAS Academy Students can avail this programme at free of charge provided if they provide any proof for having done any programme at Shankar IAS Academy</li>
                       <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}> Rs. 50/-- For others <span style={{color: '#0d3fb0'}}>(One Time Fee) </span> </li>
                      </ul>



                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-4 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                       <h2 className={`${styles.acheivername1} mb-2`}>Composition of Mock Interview Panels :</h2>
                       <p className='pt-2'>An interview panels consists of 4 members with the combinations of different fields</p>
                       <ul className="mock-interview-list pt-2" style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>All India Service Officers (Retd)</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Conferred All India Service Officers from Group I Services (Retd)</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Working Officers – Group I Cadre and above from various departments</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Subject Experts from State and Central Universities</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Experts from various fields like Journalism, Environment, etc.,</li>
                       </ul>

                       <h3 className={`${styles.acheiverfee} pt-2 mb-2`}>Mock Interview Center :</h3>
                       <ul className="mock-interview-list pt-2" style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                       <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}>Only at Anna Nagar, Chennai.</li>
                       <p className={`${styles.acheiverfee} pt-2 mb-2`}>Contact :</p>
                       <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}>76677 66266 , 044-45543082 , 044-43533445 </li>
                       
                      </ul>
                      
                      <ul className="mock-interview-list pt-2" style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                       
                      </ul>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-4 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                       <h2 className={`${styles.acheivername1} mb-2`}>Features / Benefits :</h2>
                       <ul className="mock-interview-list pt-2" style={{ listStyleType: 'none', padding: '0', margin: '0' }}>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Real Simulation of TNPSC Group I Interview</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Composite Panel to test students’ performance and enhance their individual ability to get good marks</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Cordial Feedback by every individual panel member to strengthen the areas where the students are weak</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Identification of subject sphere where students are lacking and providing solutions to cover-up such subjects.</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Stress Management</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Response Management</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Answering ability of unknown questions</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>How to take a stand on opinion-based questions</li>
                            <li style={{ marginBottom: '15px', lineHeight: '1.5', textAlign:'justify' }}><span className={`${styles.dot} pe-2`}>*</span>Enhancing of communication and answer delivery skills of the students</li>
                       </ul>
                    </div>
                </div>
                
            </div>

         {/* <div className="row pt-4 pt-md-5">
                <div className="col">
                    <p className={`${styles.sectionsubtitle} mb-0`}>Programme Fee:</p>

                        <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {prelimlist.map((item,index)=>(
                                  <li
                                    className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                    id={styles.acheiverrankspecial} key={index}
                                  >
                                    <div className="d-inline">
                                      <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                      </p>
                                    </div>
                                  </li>
                              ))}
                        </ul>
                </div>
            </div> */}

        </div>

    <Footer />

    </>
    );
};

export default TnpscGroupIMockInterview;